import { DeleteIcon, UploadIcon } from '@fluentui/react-icons-mdl2';
import { Alert, Button, ExclamationTriangleIcon, Flex, InfoIcon } from '@fluentui/react-northstar';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './edit-icon-property.css';

interface EditProps {
  icon: string;
  defaultIcon: React.ReactNode;
  onRemove: () => void;
  onUpload: (data: string | ArrayBuffer) => void;
}

const MAX_FILE_SIZE = 128 * 1024;

export const EditIconProperty: React.FC<EditProps> = ({ icon, defaultIcon, onRemove, onUpload }) => {
  const inputFile = useRef<HTMLInputElement | null>(null);
  const [fileSizeError, setFileSizeError] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <Flex column gap="gap.small" hAlign="center">
      <input type='file' id='file' ref={inputFile} className="hidden" accept="image/*" onChange={e => {
        if (!e.target.files && !e.target.files[0]) return;
        if (e.target.files[0].size > MAX_FILE_SIZE) {
          setFileSizeError(true);
          return;
        }

        setFileSizeError(false);
        const reader = new FileReader();
        reader.onloadend = () => onUpload && onUpload(reader.result);
        reader.readAsDataURL(e.target.files[0]);
      }} />
      {fileSizeError && <Alert danger content={t('icon.error.file-too-big')} icon={<ExclamationTriangleIcon />} />}
      <div className='icon-preview'>{icon && icon !== '' ? <img className='icon-image' src={icon} /> : defaultIcon}</div>
      <Flex gap="gap.medium">
        <Button icon={<UploadIcon />} content={t('ticket-details.edit-ticket-form.attachments.button.upload')} text onClick={() => inputFile.current.click()} />
        <Button icon={<DeleteIcon />} content={t('common.buttons.delete')} text onClick={() => onRemove && onRemove()} />
      </Flex>
      <Alert warning header={t('icon.note.file-types.header')} content={t('icon.note.file-types.content')} icon={<ExclamationTriangleIcon />} />
      <Alert info content={t('icon.note.size.content')} icon={<InfoIcon />} />
    </Flex>);
};

interface RenderProps {
  icon: string;
  defaultIcon: React.ReactNode;
  size?: string;
  padding?: string;
}

export const RenderIcon: React.FC<RenderProps> = ({ icon, defaultIcon, size, padding }) => {
  return (<Flex className="render-icon-container"><div className='render-icon' style={{ padding: padding ?? "12px" }}>{icon && icon !== '' ? <img src={icon} style={{ width: size ?? "40px", height: size ?? "40px" }} /> : defaultIcon}</div></Flex>);
}